fx.ns("shared.popups", class MessagePersonPopup  extends shared.popups.BasePersonPopup
{    
    constructor(title, message)
    {
        super(fx.get("assets").personSure )
        this.contentWidth = 500;
        this.contentHeight = 230;

        this._title = title;
        this._message = message;
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.close, this.cancelButton);
    }


    create()
    {
        super.create();

        this.addChild(new fx.components.Text({text:this._title, className:"title center"}));
        this.addChild(new fx.components.Text({text:this._message, className:"text center"}));

        this.okButton = new fx.components.Button({label : fx.text("Ok"), type : "filled"});
        this.addFooterChild(this.okButton, {width : 200})
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.onConfirm, this.okButton);
    }

    onConfirm()
    {
        this.close();
    }


});